import React from 'react';
import { Input, Button, Select } from '@douyinfe/semi-ui';
import { IconSearch, IconServer } from '@douyinfe/semi-icons';

const ServerSelect = ({ baseUrls, activeTabKey, onTabChange }) => {
    const options = Object.entries(baseUrls).map(([name, url]) => ({
        value: name,
        label: name,
    }));

    if (options.length <= 1) return null;

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 16,
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                color: 'var(--apple-text-secondary)',
                fontSize: 14,
                whiteSpace: 'nowrap',
                flexShrink: 0,
            }}>
                <IconServer style={{ fontSize: 16 }} />
                <span>线路选择</span>
            </div>
            <Select
                value={activeTabKey}
                onChange={onTabChange}
                optionList={options}
                size="default"
                style={{
                    flex: 1,
                    borderRadius: 12,
                    maxWidth: 280,
                }}
            />
        </div>
    );
};

const TokenInput = ({ apikey, setAPIKey, onSearch, loading, hasData, baseUrls, activeTabKey, onTabChange }) => {
    if (hasData) {
        return (
            <div style={{ marginBottom: 32, transition: 'all 0.3s' }}>
                <ServerSelect baseUrls={baseUrls} activeTabKey={activeTabKey} onTabChange={onTabChange} />
                <div style={{ display: 'flex', gap: 16 }}>
                    <Input
                        size="large"
                        showClear
                        value={apikey}
                        onChange={setAPIKey}
                        placeholder="输入您的 Key 以查看详细的使用情况"
                        prefix={<IconSearch style={{ color: 'var(--apple-text-secondary)' }} />}
                        style={{
                            flex: 1,
                            height: 52,
                            fontSize: 16,
                            borderRadius: 14
                        }}
                        onKeyDown={(e) => e.key === 'Enter' && onSearch()}
                    />
                    <Button
                        theme="solid"
                        type="primary"
                        size="large"
                        onClick={onSearch}
                        loading={loading}
                        disabled={!apikey}
                        style={{
                            padding: '0 40px',
                            height: 52,
                            borderRadius: 14,
                            fontSize: 16,
                            background: 'var(--apple-blue)'
                        }}
                    >
                        查询
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="search-area">
            <div className="apple-card glass-panel" style={{ padding: '48px 40px', textAlign: 'center' }}>
                <div style={{ marginBottom: '32px' }}>
                    <h2 style={{
                        margin: 0,
                        fontSize: '32px',
                        fontWeight: 700,
                        background: 'linear-gradient(135deg, #1d1d1f 0%, #434344 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        letterSpacing: '-0.02em'
                    }}>
                        API 令牌查询
                    </h2>
                    <p style={{ margin: '12px 0 0', color: 'var(--apple-text-secondary)', fontSize: '16px' }}>
                        输入您的 Key 以查看详细的使用情况和余额
                    </p>
                </div>

                <ServerSelect baseUrls={baseUrls} activeTabKey={activeTabKey} onTabChange={onTabChange} />

                <div style={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
                    <Input
                        size="large"
                        showClear
                        value={apikey}
                        onChange={setAPIKey}
                        placeholder="sk-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                        prefix={<IconSearch style={{ fontSize: 20, color: 'var(--apple-text-secondary)' }} />}
                        style={{
                            height: 60,
                            fontSize: 18,
                            borderRadius: 16
                        }}
                        onKeyDown={(e) => e.key === 'Enter' && onSearch()}
                    />
                    <Button
                        theme="solid"
                        type="primary"
                        size="large"
                        onClick={onSearch}
                        loading={loading}
                        disabled={!apikey}
                        style={{
                            height: 56,
                            width: '100%',
                            borderRadius: 16,
                            fontSize: 18,
                            marginTop: 8,
                            background: 'var(--apple-blue)',
                            boxShadow: '0 8px 20px rgba(0, 113, 227, 0.25)'
                        }}
                    >
                        查询详情
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default TokenInput;

